"use client";

import { createBrowserClient } from "@supabase/ssr";
import { requirePublicSupabaseEnv } from "./env";

/**
 * Browser Supabase client (client components only). Uses the publishable
 * (anon) key and cookie-based sessions shared with the server via
 * @supabase/ssr. Construct one per call site; the SDK dedupes internally.
 */
export function createClient() {
  const { url, publishableKey } = requirePublicSupabaseEnv();
  return createBrowserClient(url, publishableKey);
}
